<style lang="less" scoped>
@import "/lib/Colors.less";
.groupTask {
    font-weight: 600;
}
::v-deep .other-user-task {
    td.assignee-td {
        font-weight: 100;
        opacity: 0.6;
    }
}
::v-deep .userTask {
    font-weight: 600;
    &:before {
        font-size: 1.1em;
    }
}
.icon {
    &:before {
        margin-right: 5px;
        margin-top: 2px;
    }
}
.test-mode {
    background: #ddd;
}
.tag-filters {
    &.has-error li {
        position: relative;
        .badge-pill.btn-primary:before {
            content: "At least one filter must be selected";
            position: absolute;
            top: 100%;
            left: 0;
            pointer-events: none;
            width: max-content;

            // .popper
            background: #ffffff;
            max-width: 300px;
            border: 1px solid #cccccc;
            padding: 7.5px;
            color: #212121;
            text-align: center;
            display: inline-block;
            border-radius: 3px;
            font-size: 14px;
            font-weight: normal;
            z-index: 200000;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
            -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
            -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
        }
    }
}
</style>
<template>
    <div>
        <LoadingPlaceholder v-if="!initialLoaded" />
        <template v-if="initialLoaded">
            <div class="submissions-table-wrapper pull-left admin-content" role="main">
                <div class="float-right" @submit.prevent v-if="(availableTestModes.length > 1 && showTestMode) || possibleNewWorkflows.length > 0">
                    <button class="btn btn-primary btn-sm" type="button" id="newTaskBtn" @click.prevent="openNewModal" v-if="possibleNewWorkflows.length > 0">New Task</button>
                </div>
                <div class="d-flex align-items-center">
                    <h1 class="admin-content-heading" id="UsersHeading">Tasks</h1>
                    <div v-if="testMode" class="alert alert-test w-auto py-1 px-2 ml-3" role="alert">Displaying test tasks only</div>
                </div>
                <div class="d-flex mb-2">
                    <ul class="nav nav-tabs mb-0">
                        <li class="nav-item">
                            <a class="nav-link" tabindex="0" id="activeTabToggle" data-toggle="tab" :class="{ active: tab == 'active-tasks' }" @click.prevent="changeTab('active-tasks')">
                                <LoadingWheel class="d-inline-block" v-if="!refreshLoaded" :width="12" />
                                Active
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" tabindex="0" id="completedTabToggle" :class="{ active: tab == 'completed-tasks' }" @click.prevent="changeTab('completed-tasks')">Completed</a>
                        </li>
                        <li class="nav-item" v-if="hasIssues">
                            <a class="nav-link" tabindex="0" id="issueTabToggle" :class="{ active: tab == 'issue-tasks' }" @click.prevent="changeTab('issue-tasks')">
                                Issues
                                <span class="ml-1 badge badge-warning">{{ issueCount }}</span>
                            </a>
                        </li>
                    </ul>
                    <div class="d-flex ml-4" v-if="tab == 'active-tasks'">
                        <form class="form-inline" @submit.prevent>
                            <label class="sr-only" for="FilterTasks_Active">Filter Tasks</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Filter active tasks..." id="FilterTasks_Active" v-model="activeFilterText" @submit.prevent />
                        </form>
                        <ul class="tag-filters nav nav-tabs ml-2 mb-0" ref="tagFilters">
                            <li class="ml-2">
                                <a class="btn btn-sm badge-pill px-2 py-1" tabindex="0" id="assignedToMeTag" :class="selectedTagFilters.includes('assignedToMe-tasks') ? 'btn-primary' : 'btn-outline-dark'" @click.prevent="toggleTagFilter('assignedToMe-tasks')">Assigned To Me</a>
                            </li>
                            <li class="ml-2">
                                <a class="btn btn-sm badge-pill px-2 py-1" tabindex="0" id="toDoTag" :class="selectedTagFilters.includes('todo-tasks') ? 'btn-primary' : 'btn-outline-dark'" @click.prevent="toggleTagFilter('todo-tasks')">To Do</a>
                            </li>
                            <li class="ml-2">
                                <a class="btn btn-sm badge-pill px-2 py-1" tabindex="0" id="otherTag" :class="selectedTagFilters.includes('other-tasks') ? 'btn-primary' : 'btn-outline-dark'" @click.prevent="toggleTagFilter('other-tasks')">Other</a>
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex ml-4" v-if="tab == 'issue-tasks'">
                        <form class="form-inline" @submit.prevent>
                            <label class="sr-only" for="FilterTasks_Issue">Filter Tasks</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Filter issue tasks..." id="FilterTasks_Issue" v-model="issueFilterText" @submit.prevent />
                        </form>
                    </div>
                    <div class="d-flex ml-4" v-if="tab == 'completed-tasks'">
                        <form class="form-inline" @submit.prevent>
                            <label class="sr-only" for="FilterTasks_Completed">Filter Tasks</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Filter completed tasks..." id="FilterTasks_Completed" v-model="completedFilterText" @submit.prevent />
                        </form>
                    </div>
                    <div v-if="availableTestModes.length > 1 && showTestMode" class="d-flex align-items-center">
                        <label class="control-label mb-0 ml-4">
                            Test Tasks
                            <span class="switch">
                                <input type="checkbox" v-model="testMode" name="testMode" />
                                <span class="slider"></span>
                            </span>
                        </label>
                    </div>
                </div>
                <!-- Active -->
                <div v-if="tab == 'active-tasks'" role="region" aria-label="Active Tasks" id="activeTab">
                    <VueDataTable :server-options="tableOptions" @update:server-options="updateTableOptions" :server-items-length="totalTasksCount" :headers="activeColumns" :items="displayTasks" :loading="!refreshLoaded" table-class-name="vue-data-table" :body-row-class-name="rowClassName" :body-item-class-name="rowItemClassName" must-sort :rows-items="[5, 25, 50, 100]" theme-color="#3f51b5" :prevent-context-menu-row="false">
                        <!-- Headers -->
                        <template #header-assignee>Assignee</template>
                        <template #header-submissionUrl>
                            <span class="sr-only">View Submission</span>
                        </template>

                        <!-- Rows -->
                        <template #item-activatedDateUtc="data">
                            {{ tenantDateTime(data.activatedDateUtc) }}
                        </template>
                        <template #item-assignee="data">
                            <span class="icon" :class="[data.assigneeIsGroup ? 'groupTask icon-users' : data.assigneeIsUser ? 'userTask icon-user' : 'othersUserTask icon-user']">{{ data.assignee }}</span>
                        </template>
                        <template #item-submissionUrl="data">
                            <Promised :pending-delay="null" :promise="formUrlsPromise(data)" v-slot="reviewUrl">
                                <a :href="reviewUrl" @click.prevent="gotoSubmission($event, data)" title="Open task" class="submission-link passthrough icon icon-open" aria-label="Open web submission" />
                            </Promised>
                        </template>

                        <!-- Empty -->
                        <template #empty-message>No tasks</template>
                    </VueDataTable>
                </div>
                <!-- Completed -->
                <div v-else-if="tab == 'completed-tasks'" role="region" aria-label="Completed Tasks" id="completedTab">
                    <VueDataTable :server-options="tableOptions" @update:server-options="updateTableOptions" :server-items-length="totalTasksCount" :headers="activeColumns" :items="displayTasks" :loading="!refreshLoaded" table-class-name="vue-data-table" must-sort :rows-items="[5, 25, 50, 100]" theme-color="#3f51b5" :prevent-context-menu-row="false">
                        <!-- Headers -->
                        <template #header-assignee>Completed By</template>
                        <template #header-submissionUrl>
                            <span class="sr-only">View Submission</span>
                        </template>

                        <!-- Rows -->
                        <template #item-completedDateUtc="data">
                            {{ tenantDateTime(data.completedDateUtc) }}
                        </template>
                        <template #item-assignee="data">
                            <span class="icon" :class="[data.assigneeIsGroup ? 'groupTask icon-users' : data.assigneeIsUser ? 'userTask icon-user' : 'othersUserTask icon-user']">{{ data.assignee }}</span>
                        </template>
                        <template #item-submissionUrl="data">
                            <Promised :pending-delay="null" :promise="formUrlsPromise(data)" v-slot="reviewUrl">
                                <a :href="reviewUrl" @click.prevent="gotoSubmission($event, data)" title="Open task" class="submission-link passthrough icon icon-open" aria-label="Open web submission" />
                            </Promised>
                        </template>

                        <!-- Empty -->
                        <template #empty-message>No tasks</template>
                    </VueDataTable>
                </div>
                <!-- Issue -->
                <div v-else-if="tab == 'issue-tasks'" role="region" aria-label="Issue Tasks" id="issueTab">
                    <VueDataTable :server-options="tableOptions" @update:server-options="updateTableOptions" :server-items-length="totalTasksCount" :headers="activeColumns" :items="displayTasks" :loading="!refreshLoaded" :body-row-class-name="rowClassName" :body-item-class-name="rowItemClassName" table-class-name="vue-data-table" must-sort :rows-items="[5, 25, 50, 100]" theme-color="#3f51b5" :prevent-context-menu-row="false">
                        <!-- Headers -->
                        <template #header-assignee>Assignee</template>
                        <template #header-submissionUrl>
                            <span class="sr-only">View Submission</span>
                        </template>

                        <!-- Rows -->
                        <template #item-activatedDateUtc="data">
                            {{ tenantDateTime(data.activatedDateUtc) }}
                        </template>
                        <template #item-assignee="data">
                            <span class="icon" :class="[data.assigneeIsGroup ? 'groupTask icon-users' : data.assigneeIsUser ? 'userTask icon-user' : 'othersUserTask icon-user']">{{ data.assignee }}</span>
                        </template>
                        <template #item-submissionUrl="data">
                            <Promised :pending-delay="null" :promise="formUrlsPromise(data)" v-slot="reviewUrl">
                                <a :href="reviewUrl" @click.prevent="gotoSubmission($event, data)" title="Open task" class="submission-link passthrough icon icon-open" aria-label="Open web submission" />
                            </Promised>
                        </template>

                        <!-- Empty -->
                        <template #empty-message> No tasks </template>
                    </VueDataTable>
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, watch, computed, onActivated, onDeactivated, inject } from "vue";
import { useMainStore } from "@/mainStore";
import { asyncComputed, watchDebounced } from "@vueuse/core";
import { tenantDateTime } from "@/lib/localeDatetime.3";
import getData from "../../lib/getData";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { Promised } from "@/lib/Promised";
import NewWorkflowModal from "./NewModal.3.vue";
import SearchSubmission from "../Search/SearchSubmission.3.vue";
import "vue3-easy-data-table/dist/style.css";
import VueDataTable, { BodyItemClassNameFunction, BodyRowClassNameFunction, Header, Item, SortType, ServerOptions } from "vue3-easy-data-table";
import { showModalInjectKey, showModal } from "@/AppShell.3.vue.InjectKeys";
import { TaskTaskVm } from "@cs/TaskTaskVm";
import { TaskTaskVm as JsTask } from "@cs-ts/task-task-vm";
import { TaskIndexVm } from "@cs/TaskIndexVm";
import { TaskStartVm } from "@cs/TaskStartVm";
import { TaskStartVm as JsStart } from "@cs-ts/task-start-vm";
type tabType = "active-tasks" | "completed-tasks" | "issue-tasks";
interface JsTaskExtended extends JsTask {
    assignee: string;
    assigneeIsGroup: boolean;
    assigneeIsUser: boolean;
    assigneeInGroup: boolean;
    assigneeIsAny: boolean;
}
export default defineComponent({
    components: {
        VueDataTable,
        LoadingPlaceholder,
        LoadingWheel,
        Promised,
    },
    setup() {
        const activeSortType: SortType = "asc";
        const completedSortType: SortType = "desc";
        const activeSortBy = "activatedDateUtc";
        const completedSortBy = "completedDateUtc";

        const mainStore = useMainStore();
        const showModal = inject(showModalInjectKey) as showModal;
        const initialCreate = ref(true as boolean);
        const initialLoaded = ref(false as boolean);
        const refreshLoaded = ref(false as boolean);
        const testMode = ref(null as boolean | null);
        const currentUserId = ref(null! as string);
        const tasks = ref([] as TaskTaskVm[]);
        const groupNameMapping = ref(null! as Record<string, Record<string, string>>);
        const activeFilterText = ref(null as unknown as string);
        const issueFilterText = ref(null as unknown as string);
        const completedFilterText = ref(null as unknown as string);
        const possibleNewWorkflows = ref(null as unknown as TaskStartVm[]);
        const hasIssues = ref(false);
        const issueCount = ref(0);
        const tab = ref("active-tasks" as tabType);
        const selectedTagFilters = ref(["assignedToMe-tasks", "todo-tasks"] as string[]);
        const userNameMapping = ref(null! as Record<string, string>);
        const tagFilters = ref<HTMLInputElement>(null!);
        const tableOptions = ref<ServerOptions>({
            page: 1,
            rowsPerPage: 25,
            sortBy: "activatedDateUtc",
            sortType: "asc",
        });
        const totalTasksCount = ref(0);

        const activeColumns = computed((): Header[] => [
            {
                text: "Date",
                value: tab.value == "completed-tasks" ? "completedDateUtc" : "activatedDateUtc",
                sortable: true,
            },
            {
                text: "Label",
                value: "formLabel",
                sortable: true,
            },
            {
                text: "Task",
                value: "taskLabel",
                sortable: true,
            },
            {
                text: "Assignee",
                value: "assignee",
                sortable: true,
            },
            {
                text: "",
                value: "submissionUrl",
                sortable: false,
                width: 1,
            },
        ]);
        const displayTasks = computed(() => {
            return tasks.value.map(
                i =>
                    <JsTaskExtended>{
                        group: i.Group,
                        activatedDate: i.ActivatedDate,
                        assignToAny: i.AssignToAny,
                        completedDate: i.CompletedDate,
                        groupTenant: i.GroupTenant,
                        userInGroup: i.UserInGroup,
                        formLabel: i.FormLabel,
                        formName: i.FormName,
                        formVersion: i.FormVersion,
                        taskLabel: i.TaskLabel,
                        userId: i.UserId,
                        tenant: i.Tenant,
                        formId: i.FormId,
                        status: i.Status,
                        taskDescription: i.TaskDescription,
                        assignee: i.UserId != null ? userNameMapping.value[i.UserId] : i.Group != null && i.GroupTenant != null ? groupNameMapping.value[i.GroupTenant][i.Group] : i.AssignToAny ? "Anyone" : "Unassigned",
                        assigneeIsGroup: i.UserId == null,
                        assigneeIsUser: i.UserId == currentUserId.value,
                        assigneeIsAny: i.AssignToAny,
                        assigneeInGroup: i.UserId == null && i.UserInGroup,
                        /* TODO - remove? rename? */
                        activatedDateUtc: i.ActivatedDate,
                        completedDateUtc: i.CompletedDate,
                    },
            );
        });
        const filterText = computed(() => (tab.value == "issue-tasks" ? issueFilterText.value : tab.value == "active-tasks" ? activeFilterText.value : completedFilterText.value));
        const filterTextDebounce = ref(null as null | string);
        watchDebounced(
            () => filterText.value,
            () => {
                filterTextDebounce.value = filterText.value;
            },
            { debounce: 800 },
        );
        const availableTestModesPromise = computed(async () => {
            const userData = await mainStore.userDataPromise;
            const result = [];
            if (userData.CanReview) {
                result.push(false);
            }
            if (userData.CanTestForms) {
                result.push(true);
            }
            return result;
        });
        const availableTestModes = asyncComputed(() => availableTestModesPromise.value);
        const showTestMode = asyncComputed(async () => await mainStore.isFeatureFlagActiveAsync("TestMode"));

        const gotoSubmission = (event: Event, task: JsTask) => {
            event.preventDefault();
            openSubmissionModal(task);
        };
        const openSubmissionModal = (data: JsTask | JsStart) => {
            showModal(
                SearchSubmission,
                { form: data, triggerElement: "formId" in data ? `.submission-link[href*="${data.formId}"]` : null /*TODO?*/ },
                {
                    "before-close"() {
                        refreshData(false);
                    },
                },
            );
        };
        const openNewModal = (event: Event) => {
            showModal(NewWorkflowModal, {
                possibleNewWorkflows: possibleNewWorkflows.value,
                startCallback: (workflow: TaskStartVm) => {
                    openSubmissionModal({ tenant: workflow.Tenant, formName: workflow.FormName, formVersion: workflow.FormVersion, testMode: testMode.value } as Partial<JsStart> as JsStart);
                },
                triggerElement: event.target,
            });
        };
        const formUrlsPromise = async (task: JsTask) => {
            return await mainStore.getUrl("adminSearchReview", { areaCode: task.tenant, formId: task.formId, formName: task.formName, formVersion: task.formVersion, testMode: testMode.value, pageNumber: 1 });
        };
        watch(
            () => availableTestModes.value,
            newValue => {
                if (!newValue.includes(testMode.value!) && newValue.length > 0) {
                    testMode.value = newValue[0];
                }
            },
        );
        watch(
            () => [testMode.value, tab.value],
            async () => {
                if (initialLoaded.value && refreshLoaded.value) {
                    await refreshData(true);
                }
            },
            { deep: true },
        );
        watch(
            () => [selectedTagFilters.value, filterTextDebounce.value],
            async () => {
                if (initialLoaded.value && refreshLoaded.value) {
                    await refreshData(true);
                }
            },
            { deep: true },
        );
        watch(
            () => tableOptions.value,
            async () => {
                if (initialLoaded.value && refreshLoaded.value) {
                    await refreshData(false);
                }
            },
            { deep: true },
        );
        const refreshData = async (includeInitial: boolean) => {
            refreshLoaded.value = false;
            const completed = tab.value == "completed-tasks";
            if (completed && tableOptions.value.sortBy == "activatedDateUtc") {
                tableOptions.value.sortBy = "completedDateUtc";
                tableOptions.value.sortType = "desc";
            } else if (!completed && tableOptions.value.sortBy == "completedDateUtc") {
                tableOptions.value.sortBy = "activatedDateUtc";
                tableOptions.value.sortType = "asc";
            }
            const tableOptionsV = tableOptions.value;
            const type = tab.value == "completed-tasks" ? "completed" : tab.value == "active-tasks" ? "active" : "issue";
            if (testMode.value == null) {
                testMode.value = (await availableTestModesPromise.value)[0];
            }
            const tasksData = (await getData(mainStore, "AdminTasksIndex", () => mainStore.getUrl("adminTasksIndexData", { includeInitial: includeInitial, testMode: testMode.value, type: type, skip: (tableOptionsV.page - 1) * tableOptionsV.rowsPerPage, count: tableOptionsV.rowsPerPage, sort: tableOptionsV.sortBy as string, sortDir: tableOptionsV.sortType?.valueOf() as string, typeFilters: type != "active" ? null : selectedTagFilters.value.join(","), search: filterTextDebounce.value }))) as TaskIndexVm;
            testMode.value = tasksData.TestMode;
            currentUserId.value = tasksData.CurrentUserId;
            userNameMapping.value = tasksData.UserNameMap;
            groupNameMapping.value = tasksData.GroupNameMap;
            tasks.value = tasksData.UserTasks;
            if (includeInitial) {
                hasIssues.value = tasksData.HasIssues || false;
                issueCount.value = tasksData.IssueCount ?? 0;
                totalTasksCount.value = tasksData.TotalUserTasksCount ?? 0;
                possibleNewWorkflows.value = tasksData.PossibleNewWorkflows ?? [];
            }
            refreshLoaded.value = true;
        };
        const changeTab = (newTab: tabType) => {
            tab.value = newTab;
        };
        let tagFilterTimeoutId: ReturnType<typeof setInterval>;
        const toggleTagFilter = (tag: string) => {
            clearTimeout(tagFilterTimeoutId);
            if (selectedTagFilters.value.includes(tag)) {
                if (selectedTagFilters.value.length == 1) {
                    tagFilters.value.classList.add("has-error");
                    tagFilterTimeoutId = setTimeout(() => tagFilters.value.classList.remove("has-error"), 3000);
                    return;
                }
                selectedTagFilters.value = selectedTagFilters.value.filter(item => tag != item);
            } else {
                selectedTagFilters.value.push(tag);
                tagFilters.value.classList.remove("has-error");
            }
        };
        const rowClassName: BodyRowClassNameFunction = (item: Item): string => {
            return !item.assigneeIsUser && !item.assigneeIsGroup ? "other-user-task" : "";
        };
        const rowItemClassName: BodyItemClassNameFunction = (column: string): string => {
            return column == "submissionUrl" ? "row-actions-td" : column == "assignee" ? "assignee-td" : "";
        };

        onMounted(async () => {
            initialLoaded.value = false;
            await refreshData(true);
            if (hasIssues.value) {
                tab.value = "issue-tasks";
            }
            initialLoaded.value = true;
        });

        onActivated(async () => {
            if (initialCreate.value) {
                initialCreate.value = false;
            } else {
                await refreshData(true);
            }
            const body = document.getElementsByTagName("body")[0];
            body.classList.add("content-scroll");
            body.classList.add("no-footer");
        });

        onDeactivated(() => {
            const body = document.getElementsByTagName("body")[0];
            body.classList.remove("content-scroll");
            body.classList.remove("no-footer");
        });

        return {
            activeSortType,
            completedSortType,
            activeSortBy,
            completedSortBy,

            // Refs
            tagFilters,

            // States
            initialLoaded,
            refreshLoaded,
            testMode,
            activeFilterText,
            issueFilterText,
            completedFilterText,
            possibleNewWorkflows,
            tab,
            selectedTagFilters,
            activeColumns,
            tableOptions,
            hasIssues,
            issueCount,

            // Computed
            displayTasks,
            totalTasksCount,

            // Async Computed
            showTestMode,
            availableTestModes,

            // Methods
            gotoSubmission,
            openNewModal,
            formUrlsPromise,
            changeTab,
            toggleTagFilter,
            rowClassName,
            rowItemClassName,
            updateTableOptions: (newOptions: ServerOptions) => {
                tableOptions.value = newOptions;
            },

            tenantDateTime,
        };
    },
});
</script>
